let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7whwt"), load("cBo2a")]).then(() => parcelRequire('7xxJX'));